module.exports = __webpack_public_path__ + "static/img/edit_icon.png";